import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';

import { personaApi } from './api';

export const usePersonaDictionaryQuery = () => {
  const { isOpen } = useAppState();
  return useQuery({
    queryKey: ['persona-dictionary'],
    queryFn: personaApi.getPersonaDictionary,
    enabled: isOpen,
  });
};
